import { graphql, useMutation } from "react-relay";
import { useUploadImageLinkMutation } from "./__generated__/useUploadImageLinkMutation.graphql";
import { useCallback } from "react";

export function useUploadImageLink() {
  const [generateUploadLink, isLoadingImageLink] =
    useMutation<useUploadImageLinkMutation>(graphql`
      mutation useUploadImageLinkMutation {
        uploadImageLink {
          image {
            id
            ...Image_image
          }
          url
        }
      }
    `);

  const prepareUploadLink = useCallback(() => {
    return new Promise<{
      imageId: string;
      uploadURL: string;
    }>((resolve, reject) =>
      generateUploadLink({
        variables: {},
        onCompleted: (data) => {
          if (data.uploadImageLink?.image.id) {
            resolve({
              imageId: data.uploadImageLink.image.id,
              uploadURL: data.uploadImageLink.url,
            });
          } else {
            reject(new Error("No image ID found"));
          }
        },
        onError: (error) => {
          reject(error);
        },
      })
    );
  }, [generateUploadLink]);
  return [prepareUploadLink, isLoadingImageLink] as const;
}
